import { PROYECT, api_get, api_put, api_post, api_delete } from "../../../services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { nfcTagTypes } from "../../reducers/nfcTags/types";
import { TAXIS_STATES } from "../../../helpers/dictionary";
import { addLabelArray } from "../../../helpers/addLabelArray";

const {
  GET_NFC_TAGS,
  GET_NFC_TAGS_STATUS,
  ADD_NFC_TAG,
  EDIT_NFC_TAG,
  DELETE_NFC_TAG,
  UPDATE_NFC_TAG_STATUS,
} = nfcTagTypes;

const urlBase = `${process.env.REACT_APP_URL}${PROYECT}/nfc_tags`;

export const getNfcTags = () => {
  const url = `${urlBase}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNfcTags"));
    await api_get(url).then((resp) => {
      dispatch({
        type: GET_NFC_TAGS,
        payload: resp,
      });
    }).catch((error) => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingNfcTags"));
  };
};

export const getNfcTagsByStatus = (status = "", action = null) => {
  let nStatus = status.length === 0 ? TAXIS_STATES.FREE.name : status;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNfcTags"));
    await api_get(`${urlBase}/status/${nStatus}`).then((resp) => {
      dispatch({
        type: GET_NFC_TAGS_STATUS,
        payload: resp,
      });
      action && action();
    }).catch((error) => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingNfcTags"));
  };
};

export const addNfcTag = (form, onClose = null) => {
  const url = `${urlBase}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNfcTagActions"));
    await api_post(url, form).then((resp) => {
      dispatch({
        type: ADD_NFC_TAG,
        payload: addLabelArray(resp, "uuidTag", "brand"),
      });
      dispatch(setSnackbar("NFC Tag Creado", "success"));
      onClose && onClose();
    }).catch((error) => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingNfcTagActions"));
  };
};

export const editNfcTag = (id, form, onClose = null) => {
  const url = `${urlBase}/${id}/`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNfcTagActions"));
    await api_put(url, form).then((resp) => {
      dispatch({
        type: EDIT_NFC_TAG,
        payload: addLabelArray(resp, "uuidTag", "brand"),
      });
      dispatch(setSnackbar("NFC Tag Actualizada", "success"));
      onClose && onClose();
    }).catch((error) => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingNfcTagActions"));
  };
};

export const deleteNfcTag = (id, onClose) => {
  const url = `${urlBase}/${id}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingNfcTagActions"));
    await api_delete(url).then((_resp) => {
      dispatch({
        type: DELETE_NFC_TAG,
        payload: id,
      });
      dispatch(setSnackbar("NFC Tag Eliminada", "success"));
      onClose && onClose();
    }).catch((error) => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp("loadingNfcTagActions"));
  };
};

export const updateNfcTagStatus = (id, status) => {
  return {
    type: UPDATE_NFC_TAG_STATUS,
    payload: { id, status },
  };
};
